<template>
	<div class="container contact-guide">
		<div class="title">
			<div class="back-btn" @click="goBack()">
				<i class="fa fa-arrow-left"></i>
			</div>
			<h1>How to Get a Repair Cost</h1>
		</div>
		<div class="row">
			<div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
				<div class="faq-question">
					<h3 class="question">Step 1</h3>
					<p class="answer" v-if="partnerEnvironment !== 'likewize-au' && partnerEnvironment !== 'likewize-us'">
						Either head to the <a href="/" target="_blank">homepage</a> and enter your postcode or use live chat (found in the bottom right corner of the screen when available) and select "Quote" when asked what you need help with.
					</p>
					<p class="answer" v-if="partnerEnvironment === 'likewize-au' || partnerEnvironment === 'likewize-us'">
						Head to the <a href="/" target="_blank">homepage</a> and enter your postcode.
					</p>
				</div>
				<div class="faq-question">
					<h3 class="question">Step 2</h3>
					<p class="answer">
						Follow the steps to select your device model and tell us all the repairs you require.
					</p>
				</div>
				<div class="faq-question">
					<h3 class="question">Step 3</h3>
					<p class="answer">
						Once you reach the basket page, you'll be presented with a breakdown of your repair costs. From here, you can choose to edit your selected repairs, or add another device to be repaired during the same appointment.
					</p>
				</div>
			</div>
			<div class="col-lg-10 offset-lg-1">
				<div class="d-flex mt-5">
					<button class="btn btn-outline-secondary mx-auto" @click="showContactForms">This didnt solve my issue</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from "vuex";

	export default {
		computed: {
			...mapGetters([
				'partnerEnvironment'
			])
		},

		methods: {
			goBack() {
				this.$emit('clearSelection');
			},

			showContactForms() {
				this.$emit('showContactForms');
			}
		}
	}
</script>

<style scoped>

</style>